import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from "react-router-dom";
import axios from 'axios';
import config from '../../config/config';
import Popupform from '../../Components/Popupform/Popupform';
import { FiMapPin, FiCheckCircle, FiCalendar, FiArrowRight } from 'react-icons/fi';

const Coursemainpage = () => {
  const [tableData, setTableData] = useState([]);
  const [pageData, setPageData] = useState({});
  const { id } = useParams();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const fetchSingleCollegeData = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}/api/admin/college_page_course_details/${id}`
        );
        const fetchedData = response.data.pageCourseDetails || {};
        setPageData(fetchedData);
        setTableData(fetchedData.coursesDeatils || []);
      } catch (error) {
        console.error("Error fetching college data:", error);
      }
    };

    fetchSingleCollegeData();
  }, [id]);

  const handleOpenPopup = (e) => {
    if (e) e.preventDefault();
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    return () => { document.body.style.overflow = "auto"; };
  }, []);

  return (
    <div className="bg-white">
      {/* Dynamic Banner */}
      <div className="bg-brand-orange text-white pb-16 pt-[160px] lg:pt-[220px] relative overflow-hidden -mt-[130px] lg:-mt-[180px]">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* Logo Section */}
            <div className="w-32 h-32 bg-white rounded-2xl p-4 shadow-xl flex items-center justify-center flex-shrink-0">
              <img
                src={pageData.image ? `${config.API_BASE_URL}/${pageData.image}` : 'https://placehold.co/150'}
                alt="College Logo"
                className="max-w-full max-h-full object-contain"
              />
            </div>

            {/* Text Content */}
            <div className="flex-grow text-center md:text-left">
              <h1 className="text-3xl md:text-5xl font-bold mb-3 leading-tight">
                {pageData.bannerText || "College Name"}
              </h1>
              <p className="text-xl opacity-90 mb-4 font-light">
                {pageData.bannersubText || "Transforming Education, Shaping Futures"}
              </p>
              <div className="inline-flex items-center bg-white/20 backdrop-blur rounded-full px-4 py-1 text-sm font-medium">
                <FiMapPin className="mr-2" /> {pageData.city || "Location"}
              </div>
            </div>

            {/* CTA Button */}
            <div className="flex-shrink-0">
              <button
                onClick={handleOpenPopup}
                className="bg-white text-brand-orange px-8 py-3 rounded-full font-bold shadow-lg hover:bg-orange-50 hover:scale-105 transition transform duration-300 flex items-center"
              >
                Apply Now <FiArrowRight className="ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* About / Heading Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 border-l-4 border-brand-orange pl-4">
            {pageData?.heading || "About the Institute"}
          </h2>
          <div className="prose max-w-none text-gray-600 leading-relaxed text-lg space-y-4">
            <p>{pageData?.subHeading1}</p>
            <p>{pageData?.subHeading2}</p>
          </div>
        </div>
      </div>

      {/* Courses Table Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800">Available Courses</h2>
            <p className="text-gray-500 mt-2">Explore the wide range of programs offered</p>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden max-w-6xl mx-auto">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[800px]">
                <thead className="bg-gray-100 border-b border-gray-200">
                  <tr>
                    <th className="px-6 py-4 text-left font-bold text-gray-600">Course Name</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-600">Annual Fees</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-600">Eligibility</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-600">App. Date</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-600">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {tableData.map((item, index) => (
                    <tr key={index} className="hover:bg-orange-50/50 transition">
                      <td className="px-6 py-4">
                        <NavLink
                          to={`/branch/${pageData?._id}/${item._id}`}
                          state={{ banner: pageData.bannerText, subBanner: pageData.bannersubText, image: pageData.image }}
                          className="font-bold text-lg text-gray-800 hover:text-brand-orange transition"
                        >
                          {item.courses}
                        </NavLink>
                      </td>
                      <td className="px-6 py-4 font-semibold text-gray-700">
                        &#8377; {item.fees}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">
                        <div className="flex items-start">
                          <FiCheckCircle className="mt-1 mr-2 text-green-500 flex-shrink-0" />
                          {item.eligibility}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">
                        <div className="flex items-center">
                          <FiCalendar className="mr-2 text-gray-400" />
                          {item.applicationDate}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <button onClick={handleOpenPopup} className="text-white bg-brand-orange hover:bg-orange-700 px-4 py-2 rounded-lg text-sm font-bold transition shadow-sm">
                          Apply Now
                        </button>
                      </td>
                    </tr>
                  ))}
                  {tableData.length === 0 && (
                    <tr><td colSpan="5" className="text-center py-8 text-gray-500">No courses listed yet.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Academic Excellence / Content Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Academic Excellence</h2>
          <div className="bg-white rounded-2xl border-l-4 border-brand-orange p-6 shadow-sm">
            <p className="text-gray-600 mb-4 leading-relaxed">
              India Today is one of the leading and well-reputed English news magazines in India... (Content simplified for modern look).
              It ranked Indian colleges in fields like Science, Arts, Commerce, Management, Engineering, etc.
            </p>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Ranked 3rd in the Engineering category by NIRF 2023 and 149th globally by QS World University Rankings 2024.
            </p>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              {['Undergraduate Programs: B.Tech, B.Sc', 'Postgraduate Programs: M.Tech, MBA', 'Doctoral Programs: PhD', 'Specialized Courses: Short-term'].map((text, i) => (
                <div key={i} className="flex items-center bg-gray-50 p-3 rounded-lg">
                  <span className="w-2 h-2 bg-brand-orange rounded-full mr-3"></span>
                  <span className="text-sm font-semibold text-gray-700">{text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Popup Overlay */}
      {showPopup && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
            <button
              onClick={handleClosePopup}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border shadow-sm"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <Popupform />
          </div>
        </div>
      )}
    </div>
  );
}

export default Coursemainpage;
